module.exports = __webpack_public_path__ + "img/p8_5.716b8a94.png";